import {useEffect} from 'react';
import {UseFormReturn} from 'react-hook-form';
import {Observable, Subject} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';


export type UseFormValidationSignalHookOption<T> = {
    doItPlease$: Observable<boolean>;
    putResultHere$: Subject<boolean>;
    useFormResult: UseFormReturn<T>;
};
export const useFormValidationSignal$ = <T>({
                                                doItPlease$,
                                                putResultHere$,
                                                useFormResult,
                                            }: UseFormValidationSignalHookOption<T>
) => {
    const {trigger} = useFormResult;
    useEffect(() => {
        const subscription = doItPlease$
            .pipe(
                filter(now => now),
                switchMap(() => trigger())
            )
            .subscribe((isFormValid) => putResultHere$.next(isFormValid));
        return () => {
            subscription.unsubscribe();
        };
    }, [doItPlease$, putResultHere$, trigger]);
}
